interface BlogPostImageProps {
  src: string;
  alt: string;
}

/** Preserve the full uploaded image, including content near its edges. */
export function BlogPostImage({ src, alt }: BlogPostImageProps) {
  // eslint-disable-next-line @next/next/no-img-element
  return <img src={src} alt={alt} className="block h-auto w-full" />;
}
